
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { User } from 'solar-bo';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserEditComponent } from './user-edit.component';



@Component({
  selector: 'app-user-new',
  templateUrl: './user-new.component.html'

})
export class UserNewComponent implements OnInit, AfterViewInit {


  @Input() model: User; // = { id: '-1', fullname: '' };
  @Output() saveEvent = new EventEmitter<User>();
  @ViewChild('editform') editform: UserEditComponent;
  alertmessage: any;
  submitted = false;
  myform: FormGroup;


  constructor(
    public dialog: MatDialog
    ) {

  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.editform.saveEvent.subscribe((elemedited) => this.saveModelEvent(elemedited));
  }

  isvalid(){
    if (this.editform!=null){//en el inicio no es accesible
      return this.editform.isvalid();
    }
    else{
      return false;
    }
    
  }

  saveModel() {
    this.editform.saveModel();
  }
  saveModelEvent(elemedited: User) {
    this.saveEvent.emit(elemedited);
    this.submitted = false;
  }

  public static openModal(dialog: MatDialog, entity2edit?: User): MatDialogRef<UserNewComponent> {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "600px";
    dialogConfig.data = { entity2edit: entity2edit };

    let dialogRef: MatDialogRef<UserNewComponent>;
    dialogRef = dialog.open(UserNewComponent, dialogConfig);
    dialogRef.componentInstance.model = entity2edit;
/*     dialogRef.afterClosed().subscribe(
      data => console.log("Dialog afterClosed output:", data)
    ); */
    return dialogRef;
  }

}
